export enum AnnotationStatus {
  Annotated = 'annotated',
  EmptyAnnotation = 'emptyAnnotation',
  NotAnnotated = 'notAnnotated'
}
